export const GP_METHOD_GET = []
export const GP_METHOD_CALL = []
export const GP_METHOD_WATCH = []
export const GP_METHOD_REF = []

export interface $GP_G {}

export interface $GP_C {}

export interface $GP_W {}

export interface $GP_R {}

export interface $GP extends $GP_G, $GP_C, $GP_W, $GP_R {}
